import { Component, OnInit } from '@angular/core';
import { CfetBaseComponent, CfetService } from '../../cfet-core';
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'app-customer-profile-utf',
    templateUrl: './customer-profile-utf.component.html',
    styleUrls: ['./customer-profile-utf.component.scss'],
    standalone: false
})
export class CustomerProfileUtfComponent extends CfetBaseComponent implements OnInit {

  stepOneIcon = true;
  stepOneSelected = false;
  stepOneTickIcon = false;
  stepOneDone = true;
  stepTwoIcon = false;
  stepTwoSelected = false;
  stepTwoDone = true;
  stepThreeIcon = true;
  stepThreeSelected = true;
  disableStep = true;
  showHeading = true;
  showEligibilitySection = true;
  showInfoSection = false;
  stepTwoInformationpageDone = true;
  stepTwoProfileDone = true;
  stepThreeCreatePwdPage: boolean;
  showStepCompleteHeading = false;
  showDesktopEditButton = false;
  showMobileEditButton = false;
  editButtonClicked: boolean;
  signupCompleted = false;
  showWorkPlaceSection = false;
  selectedRole: any;
  selectedWorkPlace: any;
  selectedAddress: any;
  selectedCity: any;
  selectedStateInWorkplace: any;
  selectedZipInWorkplace: any;
  divHeight1: number;
  divHeight2: number;
  eligibilitystoredInfo: any;
  stepTwocompleted = false;
  showTermsCondition = false;
  showOTPScreen = false;
  showPasswordScreen = true;
  showInactivityModal = true;
  showWeekPassword = false;
  progressTrackerStatus: any = 'createPwd';

  constructor(private title: Title,
    private cfetService: CfetService) { super(); }

  ngOnInit() {
    this.title.setTitle(this.cfetTitles.profile.utfHtmlTitle);
    this.cfetService.isLandingPage.next(false);
    this.stepThreeCreatePwdPage = true;
    if (sessionStorage.getItem('eligibilityInfo') && Object.keys(sessionStorage.getItem('eligibilityInfo')).length !== 0) {
      this.showWorkPlaceSection = true;
      this.stepOneDone = true;
      this.signupCompleted = true;
      this.disableStep = false;
      const isIPadPro = /Macintosh/.test(navigator.userAgent) && 'ontouchend' in document;
      if (navigator.userAgent.match(/Android/i)
        || navigator.userAgent.match(/webOS/i)
        || navigator.userAgent.match(/iPhone/i)
        || navigator.userAgent.match(/iPad/i)
        || navigator.userAgent.match(/iPod/i)
        || navigator.userAgent.match(/BlackBerry/i)
        || navigator.userAgent.match(/Windows Phone/i)
        || isIPadPro) {
        this.showMobileEditButton = false;
        this.showDesktopEditButton = false;
        this.showWorkPlaceSection = false;
      } else {
        this.showMobileEditButton = false;
        this.showDesktopEditButton = false;
        this.showWorkPlaceSection = true;
      }
      this.eligibilitystoredInfo = JSON.parse(sessionStorage.getItem('eligibilityInfo'));
      this.selectedRole = this.eligibilitystoredInfo['selectedRole'];
      this.selectedWorkPlace = this.eligibilitystoredInfo['eligibilityStatus']?.selectedName;
      this.selectedAddress = this.eligibilitystoredInfo['eligibilityStatus']?.selectedAddress;
      this.selectedCity = this.eligibilitystoredInfo['eligibilityStatus']?.selectedCity;
      this.selectedStateInWorkplace = this.eligibilitystoredInfo['eligibilityStatus']?.selectedStateInWorkplace?.split(':')[0];
      this.selectedZipInWorkplace = this.eligibilitystoredInfo['eligibilityStatus']?.selectedZipInWorkplace;
    }
  }

  closeTerms(e) {
    if (e.key === 'Enter' || e.type === 'click') {
      this.showTermsCondition = false;
    }
  }

  openTermsPage(event) {
    if (event) {
      this.showTermsCondition = true;
      window.scroll(0, 0);
    }
  }

  showCodeSection(event) {
    if (event) {
      this.showPasswordScreen = false;
      this.showOTPScreen = true;
      this.progressTrackerStatus = 'confirmOtppage';
      window.scroll(0, 0);
    }
  }

  goBackToPwdPage(event) {
    if (event) {
      this.showOTPScreen = false;
      this.showPasswordScreen = true;
      this.progressTrackerStatus = 'createPwd';
    }
  }

  showCompleteProfile(event) {
    if (event) {
      this.showPasswordScreen = true;
      this.showOTPScreen = false;
      this.showWeekPassword = true;
      window.scroll(0, 0);
    }
  }
}
